import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { sort } from "fast-sort"
import ProviderJourneyScreen from "../../screen/ProviderJourneyScreen"
import { useScope } from "../SelectProjectCompanyContainer"
import { SubheaderFilter } from "../../components/Subheader"
import Send from "../../core/communication"
import { formattedList } from "../../core/utils/formatJouney"
import { useFilter } from "../../core/utils/hooks/useFilter"
import moment from "moment"
import { customToast } from "../../components/Toast"
import { removeDuplicatedArray } from "../../core/utils/manipulateArrays"

export const getIds = (data, key = "value") => {
  return data
    ?.map((item) => item[key])
    .map((item) => `'${item}'`)
    .join(",")
}

const ProviderJourneyContainer = () => {
  const [valuesToSearch, onChange, reload] = useFilter()
  const { scope, scopeType, projectsByScope } = useScope()
  const [checked, setChecked] = useState([])
  const [data, setData] = useState([])
  const [trailPosts, setTrailPosts] = useState([])
  const [values, setValues] = useState({})
  const [isOpenUsers, setIsOpenUsers] = useState(false)
  const [isOpenActions, setIsOpenActions] = useState(false)
  const [lastYear, setLastYear] = useState(null)
  const [loading, setLoading] = useState(false)
  const [loadingUsers, setLoadingUsers] = useState(false)
  const [order, setOrder] = useState(true)
  const navigate = useNavigate()
  const [content, setContent] = useState()
  const [users, setUsers] = useState([])
  const [technician, setTechnician] = useState([])

  useEffect(() => {
    const newProjects = valuesToSearch?.projects && valuesToSearch.projects.filter(row => row?.value);
    if(!Array.isArray(newProjects) || !newProjects.length) {
      const formattedProjects = projectsByScope.map(row => ({ value: row?.id, label: row?.description }));
      setValues({...(valuesToSearch || {}), projects: formattedProjects})
      onChange('projects', formattedProjects);
    }
    loadData(valuesToSearch?.projects || [{value: scope?.id}])
  }, [reload])

  useEffect(() => {
    if(values && values.select){
      setChecked([])
    }
  }, [values])

  const formatExportData = async () => {
    const formattedData = await formattedList(data, valuesToSearch?.year)
    const trails = [
      ...new Set([...formattedData.filter((item) => item?.Trilha).map((item) => item.Trilha)]),
    ]
    let years = [
      ...new Set([...data.filter((item) => item?.year_trilha).map((item) => item.year_trilha)]),
    ]
    let producersData = []
    let contentDataProducers = []

    if (valuesToSearch?.year) years = [valuesToSearch.year]

    for await (const year of years) {
      for await (const trail of trails) {
        for await (const data of formattedData) {
          if (data?.Produtores && data?.Produtores.length > 0) {
            for await (const producer of data.Produtores) {
              const hasEndedTrail = producer?.NumeroDeItens - producer?.CountVisualizado
              if (producer.ano == year && producer?.Trilha.toUpperCase() == trail) {
                const producerIndex = producersData.findIndex(
                  (row) => row?.ANO == producer.ano && row?.EMAIL === producer.Email,
                )
                if (producerIndex === -1) {
                  producersData = [
                    ...producersData,
                    {
                      NOME: producer?.Nome,
                      EMAIL: producer?.Email,
                      ANO: producer?.ano,
                      [trail]: hasEndedTrail === 0 ? "Sim" : "Não",
                    },
                  ]
                } else {
                  producersData[producerIndex] = {
                    ...producersData[producerIndex],
                    [trail]: hasEndedTrail === 0 ? "Sim" : "Não",
                  }
                }
              }
            }
          }
        }
      }
    }

    for await (const contentData of content) {
      const producerIndex = producersData.findIndex((row) => row.NOME == contentData?.Produtor)
      if (producerIndex >= 0) {
        contentDataProducers = [
          ...contentDataProducers,
          {
            CONTEÚDO: contentData.Titulo,
            PRODUTOR: contentData?.Produtor,
            TÉCNICO: contentData?.Tecnico,
            ENVIO: moment(contentData?.DataEnvio, "YYYYMMDD").format("DD/MM/YYYY"),
            ANO: moment(contentData?.DataEnvio, "YYYYMMDD").format("YYYY"),
          },
        ]
      }
    }

    for await (const producer of producersData) {
      const trailMissing = trails.filter((trail) => !producer[trail])
      trailMissing.map((trail) => {
        producer[trail] = "Não"
      })
    }

    return [producersData || [], contentDataProducers || []]
  }

  const loadData = async (projects) => {
    setLoading(true)
    let newProjects = projects || []
    let extraQuery = ""
    let type = 'project';
    
    if(!Array.isArray(newProjects) || !newProjects.length) {
      type = scopeType;
      newProjects = [{value: scope?.id}];
    }

    const groupedProjects = ['Ambev', 'SEMPROR', 'Vale', 'CUIA'];

    newProjects = newProjects
      .filter((item) => item?.value)
      .map((project) => (!groupedProjects.includes(project.label) ? `'${project?.value}'` : project?.value))
      .toString()

    if(!newProjects) return;

    if(valuesToSearch && valuesToSearch?.tags?.length){
      extraQuery += `&tags=${getIds(valuesToSearch?.tags, 'value')}`
    }

    const response = await Send.get("/DW/journey/kpi/data", `projects=${newProjects}${extraQuery}&scopeType=${type}`)

    const newYears = [
      ...new Set([
        ...response.filter((item) => item && item.year_trilha).map((item) => item.year_trilha),
      ]),
    ].sort((a, b) => b - a)

    const content = await Send.get("/DW/content/details",`projects=${newProjects}&scopeType=${type}`,)

    const trailResponse = response.filter(item => item && item.Trilha).map(item => ({ ...item, Trilha: item?.Trilha.toUpperCase() }))
      
    setData(trailResponse)
    setContent(content);

    setLastYear(valuesToSearch && valuesToSearch?.year || newYears[0] || null);
    setLoading(false);
  }

  const loadTec = async () => {
    const tec = await Send.get(`/users/tec-or-manager`, `projects='${scope?.id}'&scopeType=${scopeType}`)

    if(tec.length > 0){
      setTechnician(removeDuplicatedArray(tec, 'name').map((user) => {
        return {
          label: `${user.name}`,
          value: user.id,
        }
      }))
    }
    else {
      setTechnician([])
    }
  }

  useEffect(() => {
    loadTec()
  }, [scope?.id])

  const getTrailPosts = async () => {
    const postIds = checked.map(row => row.postId).filter(item => item);

    setTrailPosts([...new Set([...postIds])]);
  }

  const onCheckedChange = (check, value) => {
    if(Array.isArray(check)){
      if (value == "true") {
        setChecked(check)
      } else {
        setChecked([])
      }
    } else {
      if (value == "true") {
        setChecked(check ? [...checked, check] : users?.producers?.filter(user => user?.year === lastYear))
      } else {
        setChecked(check ? checked.filter((item) => item.id !== check.id) : [])
      }
    }
  }

  const openUsersModal = async (row) => {
    setIsOpenUsers(true)
    setLoadingUsers(true)

    const currentTrailId = Array.isArray(row?.Produtores) && row.Produtores[0].TrilhaId;

    if(!currentTrailId || !row?.year_trilha) {
      customToast("Trilha não encontrada!", 'error');
      return;
    }

    try {
      const response = await Send.get(`/DW/journey/trailDetails/${currentTrailId}/${row.year_trilha}`);

      if(response.error)
        throw new Error(response.error);

      if (response && response.data) {
        // setIsOpenUsers();
        setUsers(response?.data);
      }

    } catch (error) {
      customToast("Erro ao buscar informações de usuário", "error")
      console.error("Erro ao buscar informações de usuário", error)
    } finally {
      setLoadingUsers(false)
    }
  }

  const closeModal = () => {
    setTrailPosts([])
    setIsOpenUsers(false)
    setChecked([])
    setValues((current) => ({ ...current, select: null, search: null }))
  }

  const changeActionsIsOpen = (value) => {
    if (value) {
      getTrailPosts(isOpenUsers, lastYear, valuesToSearch?.projects)
    }
    setIsOpenActions(value)
  }

  useEffect(() => {
    setTrailPosts([])
  }, [isOpenUsers])

  const onHistory = (id) => {
    navigate(`/evidence/${id}`)
  }

  const onChangeUser = (field, target) => {
    return (value, realDate) => {
      if (field === "year") {
        setValues((values) => ({
          ...values,
          [field]: target ? value.target.value : value,
          date: realDate,
        }))
        return
      }
      else {
        setValues((values) => ({ ...values, [field]: target ? value.target.value : value || value?.value }))
      }
    }
  }

  return (
    <>
      <SubheaderFilter
        {...{
          setLoading,
          loading,
          loadData,
          technician,
          hasExport: true,
          isDisabledExport: loading || (data && data.length === 0),
          formatExportData,
        }}
      />
      <ProviderJourneyScreen
        data={data}
        users={filteredUsers(
          users,
          values,
        )}
        isOpenUsers={isOpenUsers}
        setIsOpenUsers={setIsOpenUsers}
        setOrder={setOrder}
        checked={checked}
        onCheckedChange={onCheckedChange}
        onChange={onChangeUser}
        order={order}
        setIsOpenActions={changeActionsIsOpen}
        isOpenActions={isOpenActions}
        closeModal={closeModal}
        openUsersModal={openUsersModal}
        onHistory={onHistory}
        loading={loading}
        loadingUsers={loadingUsers}
        year={values?.year}
        trailPosts={trailPosts}
        projectId={scope?.id}
        content={filteredContent(content, valuesToSearch)}
      />
    </>
  )
}

export default ProviderJourneyContainer

const filteredUsers = (data, values) => {
  if (!data || !data.length) {
    return [];
  }

  return data.map(item => {
    let filteredProducers = item.producers || [];

    if (values && values.search) {
      filteredProducers = filteredProducers.filter(item =>
        item.name.toLowerCase().includes(values.search.toLowerCase())
      );
    }

    if (values && values.select) {
      filteredProducers = filteredProducers.filter(item =>
        item.isFinish === values.select.value
      );
    }

    if (values && values?.tags) {
      filteredProducers = filteredProducers.filter(item =>
        item.isFinish === values.select.value
      );
    }

    return {
      ...item,
      producers: filteredProducers
    };
  });
};

const filteredContent = (data, valuesToSearch) => {
  if (valuesToSearch && valuesToSearch.tags && valuesToSearch.tags?.length) {
    return data?.filter((cont) => valuesToSearch?.tags?.filter(({ value }) => cont.Tags.find(row => row === `"${value}"`)).length)
  } else {
    return data
  }
}

